import React, { useEffect, useState } from 'react';

import Platform from '../../app/layout/header/Platform';
import { useEventContext } from '../../app/provider/useEventContext';
import Loader from '../../shared/components/Loader';
import NotFound from '../../shared/components/NotFound';

const EventPrivacyPolicyPage = () => {
    const { eventData, loading } = useEventContext();
    const [pageLoading, setPageLoading] = useState(true);

    useEffect(() => {
        if (!loading) {
            setPageLoading(false);
        }
    }, [loading]);

    if (pageLoading || loading) {
        return (
            <div className="w-full h-screen flex items-center justify-center">
                <Loader text="Loading..." />
            </div>
        );
    }

    if (!eventData || !eventData.policyProduct) {
        return <NotFound />;
    }

    const { policyProduct } = eventData;

    return (
        <div className="flex flex-col min-h-screen bg-white">
            {/* Header Components */}
            <Platform eventData={eventData} loading={loading} />

            {/* Main Content */}
            <main className="flex-grow w-full flex flex-col items-center py-12 px-6">
                <div className="w-full max-w-[1240px]">
                    {/* Title */}
                    <h1 className="font-aleo font-bold text-[32px] leading-[40px] text-[#182230] mb-4">
                        {policyProduct.eventPolicyTitle}
                    </h1>

                    {/* Description */}
                    <p className="font-noto font-normal text-[16px] leading-[24px] text-[#475467] mb-12 max-w-[900px]">
                        {policyProduct.eventPolicyDescription}
                    </p>

                    {/* Sections */}
                    <div className="flex flex-col gap-10">
                        {policyProduct.eventPolicies?.map((section, index) => (
                            <div key={index}>
                                <h3 className="font-aleo font-bold text-[24px] leading-[32px] text-[#182230] mb-4">
                                    {section.policyTitle}
                                </h3>
                                <p className="font-noto font-normal text-[16px] leading-[24px] text-[#475467] max-w-[900px]">
                                    {section.policyDescription}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default EventPrivacyPolicyPage;
